module.exports = __webpack_public_path__ + "img/floorplan_citationX_night.a60e471d.png";